import Dispatcher from 'dispatcherjs';
import { deleteJson, postJson, getJson } from 'util/xhr';
import {
    API_ENDPOINT_DISLIKE_CHECK_MODAL,
    API_ENDPOINT_DISLIKE_COMPANY_ADD,
    API_ENDPOINT_DISLIKED_COMPANY_NAMES,
    API_ENDPOINT_DISLIKE_COMPANY_REMOVE,
    API_ENDPOINT_DISLIKE_JOB_ADD,
    API_ENDPOINT_DISLIKE_JOB_REMOVE,
} from 'app/endpoints';

let dislikeCount = false;

class UserDislike {
    constructor() {
        this.events = new Dispatcher();
    }

    checkForDislikeModal(jobId) {
        getJson(
            `${API_ENDPOINT_DISLIKE_CHECK_MODAL}/${jobId}`,
            {},
            (response) => this.onCheckForDislikeModalResponse(response, jobId),
            (error) => this.onDislikeError(error, jobId),
        );
    }

    onCheckForDislikeModalResponse(response, jobId) {
        if (response.dislikedSameCompanyCount > 0) {
            dislikeCount = parseInt(sessionStorage.getItem(response.companyId), 10);

            if (dislikeCount === 1 || dislikeCount === 4) {
                this.events.emit(
                    'showDislikeModal',
                    jobId,
                    response.companyId,
                    response.companyName,
                    response.dislikedSameCompanyCount,
                    response.dislikedSameCompanyCountIsOne,
                );
            } else {
                this.dislikeJob(jobId, response.companyId);
            }
        } else {
            this.dislikeJob(jobId, response.companyId);
        }
    }

    dislikeJob(jobId, companyId) {
        const origin = window.location.pathname.split('/')[1];

        postJson(
            `${API_ENDPOINT_DISLIKE_JOB_ADD}/${jobId}`,
            { data: { origin } },
            (response) => this.onDislikeResponse(response, jobId, companyId),
            (error) => this.onDislikeError(error, jobId),
        );
    }

    onDislikeResponse(response, jobId, companyId) {
        dislikeCount = parseInt(sessionStorage.getItem(companyId), 10);
        if (dislikeCount) {
            dislikeCount += 1;
        } else {
            dislikeCount = 1;
        }
        sessionStorage.setItem(companyId, dislikeCount.toString());
        this.events.emit('onDislikeJob', jobId, response.jobDislikeId, companyId);
    }

    onDislikeError(error, jobId) {
        this.events.emit('onUnauthorized', jobId);
    }

    undoDislike(id, dislikeId, company = false) {
        let url = '';
        if (company) {
            url = `${API_ENDPOINT_DISLIKE_COMPANY_REMOVE}/${dislikeId}`;
        } else {
            url = `${API_ENDPOINT_DISLIKE_JOB_REMOVE}/${dislikeId}`;
        }
        deleteJson(
            url,
            {},
            (response) => this.onUndoDislikeResponse(response, id, company),
            (error) => this.onDislikeError(error),
        );
    }

    async onUndoDislikeResponse(response, id, company) {
        try {
            const dislikeObject = await this.fetchDislikedCompanyNames();
            this.events.emit('onUndoDislike', id, company, response.ignoreJobIds, dislikeObject);
        } catch (error) {
            this.onDislikeError(error);
        }
    }

    dislikeCompany(companyId, companyName) {
        const origin = window.location.pathname.split('/')[1];

        postJson(
            `${API_ENDPOINT_DISLIKE_COMPANY_ADD}/${companyId}`,
            { data: { origin } },
            (response) => this.onCompanyDislikeResponse(response, companyId, companyName),
            (error) => this.onDislikeError(error),
        );
    }

    fetchDislikedCompanyNames() {
        return new Promise((resolve, reject) => {
            getJson(
                `${API_ENDPOINT_DISLIKED_COMPANY_NAMES}`,
                {},
                (response) => resolve(response),
                (error) => reject(error),
            );
        });
    }

    async onCompanyDislikeResponse(response, companyId, companyName) {
        dislikeCount = parseInt(sessionStorage.getItem(companyId), 10);
        dislikeCount += 1;
        sessionStorage.setItem(companyId, dislikeCount.toString());

        try {
            const dislikeObject = await this.fetchDislikedCompanyNames();
            this.events.emit(
                'onDislikeCompany',
                companyId,
                response.companyDislikeId,
                companyName,
                response.ignoreJobIds,
                dislikeObject,
            );
        } catch (error) {
            this.onDislikeError(error);
        }
    }
}

// Singletons
export const userDislike = new UserDislike();
